import type * as React from 'react';

import { cn } from '@/lib/utils';

export function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        'flex w-full rounded-lg border border-input bg-card px-3 py-2 text-sm transition-[color,border-color,box-shadow]',
        'placeholder:text-subtle-foreground hover:border-input-hover focus-visible:border-ring-strong focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
